import { hasAnalyticsConsent } from "./consent";

declare global {
  interface Window {
    dataLayer?: any[];
    gtag?: (...args: any[]) => void;
  }
}

export function gtag(...args: any[]): void {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag === "function") {
    window.gtag(...args);
  } else {
    window.dataLayer.push(args);
  }
}

export function trackEvent(name: string, params?: Record<string, any>): void {
  if (typeof window === "undefined") return;
  try {
    gtag("event", name, params);
  } catch (err) {
    console.warn("GA trackEvent error:", err);
  }
}

export function setAnalyticsUser(authId: string | null): void {
  if (typeof window === "undefined") return;
  try {
    if (!authId) {
      gtag("set", "user_id", null);
      return;
    }

    if (!hasAnalyticsConsent()) {
      return;
    }

    gtag("set", "user_id", authId);
  } catch (err) {
    console.warn("GA setAnalyticsUser error:", err);
  }
}
